//En este js se gestionarán los dintitos fallos de los campos que vallan surgiendo

//Con está funcion gestionaremos los distintos errores que hay al cambiar campos a tiempo real en el onchange
export const handleChangeErrors = (
  name,
  value,
  estadoCampoReque,
  estadoCampoSintaxis,
  setEstadoCampoReque,
  setestadoCampoSintaxis,
  setEstadosActualizados,
  primerEnvio
) => {
  // Hacemos copias de los estados de validación
  let nuevoEstadoCampoReque = { ...estadoCampoReque };
  let nuevoEstadoCampoSintaxis = { ...estadoCampoSintaxis };

  // Expresiones regulares
  const correoFallido = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  const telefonoFallido = /^(\(?\d{3}\)?[-]?\d{3}[-]?\d{3})$/;


  if (primerEnvio !== false) {
    // Validación de campo vacío
    nuevoEstadoCampoReque[name] = value.trim() === "";

    // Validación de sintaxis según el campo
    if (name === "correo") {
      nuevoEstadoCampoSintaxis["correoMal"] = value.length === 0 ? false : !correoFallido.test(value);
    }

    if (name === "telefono") {
      nuevoEstadoCampoSintaxis["telefonoMal"] = value.length === 0 ? false : !telefonoFallido.test(value);
    }

  }

  // Se envían los cambios de estado
  setEstadoCampoReque(nuevoEstadoCampoReque);
  setestadoCampoSintaxis(nuevoEstadoCampoSintaxis);
  setEstadosActualizados(true);
};

//Funcion que gestiona los los distintos errores que hay al cambiar campos al hacer el submit
//La gestion de errores el la misma que el onChange pero los datos para verificar estos datos 
//En el caso del onchange el nombre a tiempo real y el el caso del submit devemos comprobar el form data
export const handleSubmitErrors = (
  curso,
  camposRequeridos,
  formData,
  estadoCampoReque,
  estadoCampoSintaxis,
  setEstadoCampoReque,
  setEstadoCampoSintaxis,
  setEstadosActualizados
) => {
  let nuevoEstadoCampoReque = { ...estadoCampoReque };
  let nuevoEstadoCampoSintaxis = { ...estadoCampoSintaxis };
  const correoFallido = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
  const telefonoFallido = /^(\(?\d{3}\)?[-]?\d{3}[-]?\d{3})$/;


  for (const campo in camposRequeridos) {

    // console.log("formData[campo].lenght", formData[campo]);

    if (!formData[campo] || formData[campo].lenght == 0 && estadoCampoReque[campo]) {
      nuevoEstadoCampoReque[campo] = true;
    } else if (estadoCampoReque[campo]) {
      nuevoEstadoCampoReque[campo] = false;
    }


    if (!(curso?.SubCategorium)) {

      nuevoEstadoCampoReque["anexo"] = false;
    }


    switch (formData?.situacionLaboral) {
      case "Desempleado":
        nuevoEstadoCampoReque["caNomina"] = false;
        nuevoEstadoCampoReque["iAEconomicas"] = false;
        nuevoEstadoCampoReque["reciboAutonomos"] = false;

        nuevoEstadoCampoReque["funcionario"] = false;
        if (!formData.renovacionEmpleo) {

          nuevoEstadoCampoReque["renovacionEmpleo"] = true;

        } else {
          nuevoEstadoCampoReque["renovacionEmpleo"] = false;
        }
        break;
      case "Trabajador en activo":
        nuevoEstadoCampoReque["renovacionEmpleo"] = false;
        nuevoEstadoCampoReque["iAEconomicas"] = false;
        nuevoEstadoCampoReque["reciboAutonomos"] = false;

        if (!formData.caNomina) {

          nuevoEstadoCampoReque["caNomina"] = true;
        } else {
          nuevoEstadoCampoReque["caNomina"] = false;
        }
        break;
      case "Autónomo":
        nuevoEstadoCampoReque["renovacionEmpleo"] = false;

        nuevoEstadoCampoReque["caNomina"] = false;
        if (!formData.iAEconomicas || !formData.reciboAutonomos) {

          nuevoEstadoCampoReque["iAEconomicas"] = true;
          nuevoEstadoCampoReque["reciboAutonomos"] = true;

        } else {
          nuevoEstadoCampoReque["iAEconomicas"] = false;
          nuevoEstadoCampoReque["reciboAutonomos"] = false;

        }
        break;
      case "Erte":
        nuevoEstadoCampoReque["caNomina"] = false;
        nuevoEstadoCampoReque["iAEconomicas"] = false;
        nuevoEstadoCampoReque["reciboAutonomos"] = false;

        nuevoEstadoCampoReque["renovacionEmpleo"] = false;

        break;
      default:
        break;
    }
  }


  if (formData.esFuncionario === "No") {
    nuevoEstadoCampoReque['esFuncionario'] = false;
    nuevoEstadoCampoReque['funcionario'] = false;
  }

  if (curso?.requisito?.Id === 0) {
    nuevoEstadoCampoReque['tituloA'] = false;
  }

  if (curso?.subcategoriaId == null) {
    nuevoEstadoCampoReque['anexo'] = false;
  }

  if (!correoFallido.test(formData.correo)) {
    if (formData.correo.length === 0) {
      nuevoEstadoCampoSintaxis['correoMal'] = false;
    } else {
      nuevoEstadoCampoSintaxis['correoMal'] = true;
    }
  } else {
    nuevoEstadoCampoSintaxis['correoMal'] = false;
  }

  if (!telefonoFallido.test(formData.telefono)) {
    if (formData.telefono.length === 0) {
      nuevoEstadoCampoSintaxis['telefonoMal'] = false;
    } else {
      nuevoEstadoCampoSintaxis['telefonoMal'] = true;
    }
  } else {
    nuevoEstadoCampoSintaxis['telefonoMal'] = false;
  }
  


  setEstadoCampoReque(nuevoEstadoCampoReque);
  setEstadoCampoSintaxis(nuevoEstadoCampoSintaxis);

  setEstadosActualizados(true);
  //console.log(nuevoEstadoCampoReque);
  //console.log(nuevoEstadoCampoSintaxis);
};


//En esta funcion comprobaremos si todos los datos introducidos son correcto 
//Es decir que el comprobador de estado ninguno se halla activado a true
export const todosDatosCorrectos = (curso, formData, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque) => {

  //Según la situcación selecionada se desactivarán los ficheros que no son requeridos de esa categoría
  // Verificar si todos los valores de formDataSinCurso están vacíos
  const formDataVacio = Object.values(formData).every(value => value === '');

  //Con esta funcion podremos ver si comprobando todos los campos se han rellenado correctamente,
  //Si no ha saltado ninguna alerta, es decir que no a dado ningun error y por lo tanto el estado esta a false
  //Significará que todos los datos estan introducidos correctamente
  let todosCamposFalse = () => {
    const todosRequeFalse = Object.values(estadoCampoReque).every(valor => valor === false && !formDataVacio);
    const todosSintaxixFalse = Object.values(estadoCampoSintaxis).every(valor => valor === false && !formDataVacio);
    // console.log("todosRequeFalse", todosRequeFalse);

    return todosRequeFalse && todosSintaxixFalse;
  };
  //En caso de que la funcion anterior nos de false he creado una funcion que nos muestra los campos que 
  //la alerta está activada
  //Funcion opcional
  const camposFalse = () => {
    const camposRequeFalse = [];
    for (const campo in estadoCampoReque) {
      // console.log("campo ", campo);
      // console.log("campo", estadoCampoReque[campo]);
      if (estadoCampoReque.hasOwnProperty(campo) && estadoCampoReque[campo] == true) {
        console.log("campo ", campo);
        camposRequeFalse.push(campo);
      }
    }

    const camposSintaxixFalse = [];
    for (const campo in estadoCampoSintaxis) {
      if (estadoCampoSintaxis.hasOwnProperty(campo) && estadoCampoSintaxis[campo] == true) {
        camposSintaxixFalse.push(campo);
      }
    }

    return {
      camposRequeFalse, camposSintaxixFalse
    };
  };

   console.log("camposAFalso", camposFalse());
   console.log("todosCampos", todosCamposFalse());

  return {
    todosCamposFalse
  };
}